// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Dropdown, Menu, Avatar, Typography } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

const userMgtUrl = process.env.REACT_APP_USER_MANAGEMENT_URL

class Account extends React.Component {
  handleMenuClick = item => {
    switch (item.key) {
      case 'help':
        window.open('https://wiki.grab.com/display/GEO/Camera+Management+Tool+help+page', '_blank')
        break
      case 'sign-out':
        this.props.logOut().then(() => {
          this.props.history.replace('/login')
        })
        break
      case 'profile':
        this.props.history.replace('/profile')
        break
      case 'user-management':
        // this.props.history.replace('/admin')
        window.open(userMgtUrl, '_blank')
        break
      case 'camera-management':
        this.props.history.replace('/cameras/management')
        break
      default:
        break
    }
  }

  getDropDownOverLay () {
    const { roles } = this.props.rbacCurrent
    const menuItems = []
    if (Object.keys(roles).some(name => name === 'admin')) {
      menuItems.push(<Menu.Item key='user-management'>User Management</Menu.Item>)
    }
    return (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key='help'>Help</Menu.Item>
        {menuItems}
        <Menu.Divider />
        <Menu.Item key='sign-out'>Quit</Menu.Item>
      </Menu>
    )
  }

  render () {
    const { userInfo } = this.props
    if (!userInfo) {
      return <span />
    }
    const imageUrl = userInfo.google && userInfo.google.picture
    return (
      <Dropdown trigger='click' overlay={this.getDropDownOverLay()}>
        <span className='account'>
          <Avatar size='small' src={imageUrl} className='avatar' />
          <Typography.Text> {userInfo.username}</Typography.Text>
        </span>
      </Dropdown>
    )
  }
}

const mapState2Props = ({ auth: { isAuthorized, userInfo }, rbacCurrent }) => ({ isAuthorized, userInfo, rbacCurrent })
const mapDispatch2Props = ({ auth: { logOut } }) => ({ logOut })

export default withRouter(connect(mapState2Props, mapDispatch2Props)(Account))
